import INTERNAL_LINKS from '../../../enums/InternalLinks';
import OtherCertificationsList from '../../../pages/OtherCertifications/List/index';

import { CustomButton } from '../../../components';
import { Avatar, Card, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { BulbOutlined, PlusOutlined } from '@ant-design/icons';
const { Title, Paragraph } = Typography;

const NaturalPersonFormCertificationsSection = ({
  readOnly = false,
  personID,
  divRef,
}) => {
  return (
    <Card
      size={'small'}
      bordered={false}
      title={
        <Title level={3}>
          <Avatar
            size={32}
            icon={<BulbOutlined />}
            style={{ backgroundColor: '#20b2aa', color: 'white' }}
            shape="square"
          />{' '}
          Otras certificaciones (opcional)
        </Title>
      }
    >
      <div ref={divRef}>
        {readOnly ? (
          <Paragraph>
            Revise aquí únicamente las certificaciones que evidencien la
            idoneidad en algún tema específico requerido por Corpoeducación
          </Paragraph>
        ) : (
          <>
            <Paragraph>
              Registre aquí únicamente las certificaciones que evidencien su
              idoneidad en algún tema específico requerido por Corpoeducación y
              que no lo haya cargado anteriormente
            </Paragraph>
            <CustomButton
              type={'default'}
              className={'ant-btn-info'}
              htmlType="button"
              text={
                <Link to={`${INTERNAL_LINKS.OTHER_CERTIFICATIONS}/${personID}`}>
                  <PlusOutlined /> Agregar otras certificaciones
                </Link>
              }
            />
          </>
        )}
        <OtherCertificationsList idTercero={personID} readOnly={readOnly} />
      </div>
    </Card>
  );
};

export default NaturalPersonFormCertificationsSection;
